import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Input, Button, message } from 'antd';
import { useDispatch } from 'react-redux'
import { fetchMenuList } from '@/store/modules/permission'
import { sendPhoneCodeAPI } from '@/apis/common'
import { bindPhoneAPI } from '@/apis/user'
import { checkPhone, checkLogin } from '@/utils'
import { getUserInfo, setUserInfo as _setUserInfo } from '@/utils/token'
import { getMenuList } from '@/utils/menu'
import styles from './index.module.scss'

let Interval = null
export default function Bind() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [userInfo, setUserInfo] = useState({})
  const [menuList, setMenuList] = useState([])
  const [count, setCount] = useState(60)
  const [intervalStatus, setIntervalStatus] = useState(false)
  const [formData, setFormData] = useState({
    wxAccount: '',
    phone: '',
    smscode: '',
  })
  const changePhone = e => {
    setFormData({
      ...formData,
      phone: e.target.value
    })
  }
  const sendCodeMsg = () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    if(!checkPhone(formData.phone)) {
      message.error('手机号格式不正确')
      return
    }
    
    sendPhoneCodeAPI({ phone: formData.phone }).then(res => {
      if (res.success === true) {
        if(res.message === '验证码发送失败') {
          message.error(res.message)
        } else {
          message.success('发送成功')
          let timer = 60
          setIntervalStatus(true)
          setCount(timer)
          Interval = setInterval(() => {
            timer--
            setCount(timer)
            if (timer <= 0) {
              clearInterval(Interval)
              setIntervalStatus(false)
            }
          }, 1000)
        }
      }
    })
  }
  const changeForm = e => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    if('phone' in e) {
      setFormData({
        ...formData,
        phone: e.phone
      })
    } else if('wxAccount' in e) {
      setFormData({
        ...formData,
        wxAccount: e.wxAccount
      })
    } else if('smscode' in e) {
      setFormData({
        ...formData,
        smscode: e.smscode
      })
    }
  }
  const submitForm = async values => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
    }
    setFormData({
      ...formData,
      wxAccount: values.wxAccount,
      phone: values.phone,
      smscode: values.smscode,
    })
    if(!checkPhone(values.phone)) {
      message.error('手机号格式不正确')
      return
    }
    if(values.smscode.length !== 6) {
      message.error('验证码格式不正确')
      return
    }
    const res = await bindPhoneAPI(formData)
    if (res.success === true) {
      message.success('信息完善成功')
      userInfo.isPhone = true
      setUserInfo({
        ...userInfo,
        isPhone: true
      })
      _setUserInfo(userInfo)
      if(menuList.length > 0) {
        navigate(menuList[0]?.children[0]?.key || '/managecenter/housetree')
        return
      }
    } else {
      message.error(res.message)
    }
  }
  useEffect(() => {
    async function fetchData() {
      let userinfo = getUserInfo()
      setUserInfo(userinfo)
      if(!checkLogin()) {
        setTimeout(() => {
          navigate('/')
        }, 2000)
      }
      await dispatch(fetchMenuList())
      let menu = getMenuList()
      console.log('%c [ menu ]-116', 'font-size:13px; background:pink; color:#bf2c9f;', menu)
      setMenuList(menu)
      if(!userinfo || !userinfo.token) {
        navigate('/')
        return
      }
      if(userinfo.isPhone && menu.length > 0) {
        let path = menu[0]?.children[0]?.key || '/managecenter/housetree'
        navigate(path)
        return
      }
    }
    fetchData();
  }, [])

  return (
    <div className={['flex-col', 'height-100'].join(' ')}>
      <div className={['bg-white', styles['top']].join(' ')}>
        <div className={['flex-between', 'height-100', 'margin-auto', styles['main']].join(' ')}>
          <img src="/images/logo.png" className={styles['logo']} />
        </div>
      </div>
      <div className={['flex-1'].join(' ')}>
        { userInfo?.isPhone ? (
          <div className={[styles['bind-success'], 'font-size24', 'align-center'].join(' ')}>
            <div className={['flex-center', 'margin-top-24', 'margin-bottom-32'].join(' ')}>
              <img src="/images/17.png" className="avatar-36" />
              <div className={['margin-left-10', 'font-weight-600'].join(' ')}>请等待客服开通权限</div>
            </div>
            <div className="line-height-32">或者你也可以</div>
            <div className="line-height-32">扫码加客服微信</div>
            <img src="/images/13.png" className={[styles['qrcode'], 'margin-top-24'].join(' ')} />
          </div>
        ) : (
          <div className={[styles['bind'], 'bg-white', 'border-radius-8', 'padding-left-80', 'padding-right-80', 'padding-top-80', 'padding-bottom-60'].join(' ')}>
            <div className="flex-center">
              <img src={userInfo?.avatar} className="avatar-32" />
              <div className={['font-weight-600', 'font-size24', 'margin-left-10'].join(' ')}>{ decodeURIComponent(userInfo?.userName) }</div>
            </div>
            <div className={['flex-center', 'margin-top-24'].join(' ')}>
              <img src="/images/17.png" className="avatar-24" />
              <div className='font-size16 margin-left-10'>登录成功，请完善资料</div>
            </div>
            <Form initialValues={formData} onValuesChange={changeForm} onFinish={submitForm}>
              <Form.Item name="wxAccount">
                <Input placeholder="微信号" allowClear className={['margin-top-32', 'bg-fafafa', 'padding-top-10', 'padding-bottom-10'].join(' ')} />
              </Form.Item>
              <Form.Item name="phone">
                <div className={[styles['phone'], 'flex', 'align-items', 'bg-fafafa'].join(' ')}>
                  <Input placeholder="手机号" className={[styles['phoneInput'], 'flex-1', 'bg-fafafa'].join(' ')} onChange={changePhone} />
                  <div className={[styles['codeBtn'], 'font-size16', 'green', 'cursor-pointer'].join(' ')} onClick={sendCodeMsg}>{intervalStatus ? count + '秒后重新发送' : '发送验证码'}</div>
                </div>
              </Form.Item>
              <Form.Item name="smscode">
                <Input placeholder="验证码" allowClear className={['bg-fafafa', 'padding-top-10', 'padding-bottom-10'].join(' ')} />
              </Form.Item>
              <Form.Item>
                <Button block size="large" htmlType="submit" className={[styles['submitBtn'], 'bg-green', 'white', 'padding-top-10', 'padding-bottom-10', 'font-size16', 'line-height-24'].join(' ')}>
                  提交
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
      </div>
    </div>
  )
}
